(function() {
  const countdownTimers = new WeakMap();

  function initCountDownForElement(countdown) {
    if (!countdown || countdownTimers.has(countdown)) return;

    // We define our labels here
    const dayLabel = window.countdown && window.countdown.day ? window.countdown.day : 'd';

    function getNextMidnightEST() {
      const now = new Date();
      // Get current time in New York (EST/EDT)
      const estTimeStr = now.toLocaleString("en-US", { timeZone: "America/New_York" });
      const estDate = new Date(estTimeStr);
      
      // Calculate target: Midnight of the next day in EST
      const midnightEST = new Date(estDate);
      midnightEST.setHours(24, 0, 0, 0); 

      // Return the difference in milliseconds relative to the real current time
      return midnightEST.getTime() - estDate.getTime();
    }

    function updateCountdown() {
      const distance = getNextMidnightEST();

      // If for some reason it's 0, don't delete it, just wait for next tick
      if (distance < 0) return;

      const d = Math.floor(distance / (1000 * 60 * 60 * 24));
      const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((distance % (1000 * 60)) / 1000);

      // Pad numbers with leading zeros (e.g., 05 instead of 5)
      const hh = h.toString().padStart(2, '0');
      const mm = m.toString().padStart(2, '0');
      const ss = s.toString().padStart(2, '0');

      if (countdown.classList.contains('product-countdown')) {
        const bar = countdown.querySelector('.product-countdown-bar');
        if (bar) {
          bar.innerHTML = `
            <span class="product-countdown-num"><span>${hh}</span></span>
            <span class="divider">:</span>
            <span class="product-countdown-num"><span>${mm}</span></span>
            <span class="divider">:</span>
            <span class="product-countdown-num"><span>${ss}</span></span>
          `;
        }
      } else {
        // Updated to remove the 'Day' display to match your 3-column layout
        countdown.innerHTML = `
          <span class="num">${hh}<span class="icon">:</span></span>
          <span class="num">${mm}<span class="icon">:</span></span>
          <span class="num">${ss}</span>
        `;
      }
      countdown.classList.add('is_show');
    }

    updateCountdown();

    const timer = setInterval(updateCountdown, 1000);
    countdownTimers.set(countdown, timer);
  }

  // --- REST OF THE ORIGINAL OBSERVER CODE REMAINS THE SAME ---
  function destroyCountDownForElement(countdown) {
    const timer = countdownTimers.get(countdown);
    if (timer) {
      clearInterval(timer);
      countdownTimers.delete(countdown);
    }
  }

  function initializeCountdownsInScope(scope) {
    // Note: Adjusted selector to ensure it catches your timer element
    const countdowns = (scope || document).querySelectorAll('[data-countdown-id], .countdown-timer');
    if (countdowns.length > 0) {
      countdowns.forEach(initCountDownForElement);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initializeCountdownsInScope(document);

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach(mutation => {
        mutation.addedNodes && mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('.countdown-timer')) {
              initCountDownForElement(node);
            }
            const foundCountdowns = node.querySelectorAll && node.querySelectorAll('.countdown-timer');
            if (foundCountdowns && foundCountdowns.length > 0) {
              foundCountdowns.forEach(initCountDownForElement);
            }
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();